
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import "@/design/index.scss";
import store from '@/state/store';
import { ToastPlugin } from 'bootstrap-vue'

import axiosConfig from "./helpers/axiosConfig";

import App from './App.vue'

import i18n from './i18n'

import tinymce from 'vue-tinymce-editor'
import {
  compactNumber,
  convertToLocaleTimeString,
  env,
  markdownText,
  serbianDateFormat,
  snakeToWords
} from "@/state/helpers";
import Scheduler from "@/plugins/tasks/Scheduler";
import TextareaAutosize from 'vue-textarea-autosize'
import SentryLogger from "@/plugins/sentry/SentryLogger";
import {Can} from "@/directives/can";
import nativeFunctionsConfig from "@/nativeFunctionsConfig";

Vue.use(SentryLogger, env('VUE_APP_SENTRY_DSN'))

nativeFunctionsConfig();

Vue.directive('can', Can)

Vue.use(TextareaAutosize);

Vue.component('tinymce', tinymce);

Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
Vue.config.productionTip = false;

axiosConfig();

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require('vue-chartist'));
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
});
Vue.component('apexchart', VueApexCharts);

Vue.filter('markdownText', markdownText)
Vue.filter('compactNumber', compactNumber)
Vue.filter('localeTimeString', convertToLocaleTimeString)
Vue.filter('serbianDateFormat', serbianDateFormat)
Vue.filter('snakeToWords', snakeToWords)

Vue.use(Scheduler)
Vue.use(ToastPlugin)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
